import { Button } from '@elements/button'
import { ClockIcon } from '@heroicons/react/24/outline'
import { analytics } from '@lib/analytics'
import { Venue } from 'types/model'

import { useOpenState } from '@hooks/open-state'
import { ReservationModal } from '@modules/booking/views/reservation-modal'
import {
  inventoryWidgetAttributions,
  widgetAttribution,
} from '@modules/widget/constants'
import { TrackEvent } from '@utils/analytics/types'

interface ReservationRequestButtonProps {
  venue: Venue
  title?: string
  date?: string
  attributionId?: string | null
  affiliateId?: string | null
  onReservationModalOpen?: () => void
}

export function ReservationRequestButton({
  venue,
  title = 'Request a Table',
  date = new Date().toISOString(),
  attributionId,
  affiliateId,
  onReservationModalOpen,
}: ReservationRequestButtonProps) {
  const reservationModal = useOpenState()

  const reservationFormAttribution =
    attributionId && inventoryWidgetAttributions.has(attributionId)
      ? widgetAttribution.reservationForm
      : attributionId

  return (
    <>
      <Button.Primary
        className='w-full !text-base'
        rightIcon={ClockIcon}
        onClick={() => {
          analytics.trackEvent({
            event: TrackEvent.Click_RequestTable,
            venue,
            eventData: {
              currency: venue.currencyCode,
            },
          })

          if (onReservationModalOpen) {
            onReservationModalOpen()
          } else {
            reservationModal.open()
          }
        }}
        sm
      >
        {title}
      </Button.Primary>
      <ReservationModal
        {...reservationModal}
        venue={venue}
        date={date}
        attributionId={reservationFormAttribution}
        affiliateId={affiliateId}
      />
    </>
  )
}
